// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const headedChartLayout = "HeadedChartLayout__headedChartLayout__FyJnC";
export const fullHeight = "HeadedChartLayout__fullHeight__b6Lh6";
export const isMobile = "HeadedChartLayout__isMobile__jy0ue";
export const header = "HeadedChartLayout__header__A5-qv";
export const preloader = "HeadedChartLayout__preloader__jrcIS";
export const chartWrapper = "HeadedChartLayout__chartWrapper__8vcVM";
export const chart = "HeadedChartLayout__chart__7egdA";
export const legend = "HeadedChartLayout__legend__UrjhW";